<glxy-page>
  <glxy-page-toolbar>
    <glxy-page-title>Edit User</glxy-page-title>
    <glxy-page-nav>
      <glxy-page-nav-button
        [previousPageTitle]="'USERS.TITLE' | translate"
        [previousPageUrl]="'/bc-admin'"
      ></glxy-page-nav-button>
    </glxy-page-nav>
    <glxy-page-actions>
      <button mat-flat-button color="primary" (click)="resetPassword()">
        {{ 'USERS.ACTIONS.SEND_RESET_PASSWORD_EMAIL' | translate }}
      </button>
    </glxy-page-actions>
  </glxy-page-toolbar>
  <glxy-page-wrapper>
    <mat-tab-group
      *ngIf="hasCustomFieldAccess$ | async; else fixedFields"
      mat-stretch-tabs="false"
      mat-align-tabs="start"
      animationDuration="0ms"
      class="edit-user-tab-group"
    >
      <mat-tab>
        <ng-template mat-tab-label>
          <span>
            {{ 'USERS.FORM_TAB.BASIC' | translate }}
          </span>
        </ng-template>
        <ng-container *ngTemplateOutlet="fixedFields"></ng-container>
      </mat-tab>
      <mat-tab>
        <ng-template mat-tab-label>
          <span data-action="clicked-user-custom-field-tab">
            {{ 'USERS.FORM_TAB.CUSTOM_FIELDS' | translate }}
          </span>
        </ng-template>
        <ng-container *ngTemplateOutlet="customFields"></ng-container>
      </mat-tab>
    </mat-tab-group>

    <div class="form-actions">
      <button mat-flat-button color="primary" (click)="updateUser()" [disabled]="isUpdatingUser">
        <ng-container *ngIf="!isUpdatingUser; else loadingSpinner">
          {{ 'EDIT_BUSINESS_USER_PAGE.SUBMIT_BUTTON' | translate }}
        </ng-container>
        <ng-template #loadingSpinner>
          <glxy-loading-spinner></glxy-loading-spinner>
        </ng-template>
      </button>
      <button mat-stroked-button (click)="cancelUpdateUser()" *ngIf="!isUpdatingUser">
        {{ 'COMMON.ACTION_LABELS.CANCEL' | translate }}
      </button>
    </div>
  </glxy-page-wrapper>
</glxy-page>

<ng-template #fixedFields>
  <mat-card appearance="outlined" *ngIf="user$ | async as user; else loadingPage" class="card-container-wrapper">
    <mat-card-header>
      <mat-card-title>
        {{ 'EDIT_BUSINESS_USER_PAGE.TITLE' | translate }}
      </mat-card-title>
    </mat-card-header>
    <mat-card-content>
      <form [formGroup]="userFormGroup">
        <glxy-input
          [required]="false"
          [label]="'CREATE_BUSSINESS_USER_PAGE.FIRST_NAME'"
          [formControl]="userFormGroup.controls.first_name"
          [disableAutoComplete]="true"
        ></glxy-input>
        <glxy-input
          [required]="false"
          [label]="'CREATE_BUSSINESS_USER_PAGE.LAST_NAME'"
          [formControl]="userFormGroup.controls.last_name"
          [disableAutoComplete]="true"
        ></glxy-input>
        <glxy-input
          [required]="false"
          [label]="'CREATE_BUSSINESS_USER_PAGE.GREETING_NAME'"
          [formControl]="userFormGroup.controls.greeting_name"
          [hint]="'CREATE_BUSSINESS_USER_PAGE.GREETING_NAME_HINT'"
          [disableAutoComplete]="true"
        ></glxy-input>
        <glxy-email-input
          [formControl]="userFormGroup.controls.user_email"
          [required]="true"
          [label]="'CREATE_BUSSINESS_USER_PAGE.USER_EMAIL'"
        ></glxy-email-input>
        <glxy-phone-input
          [formControl]="userFormGroup.controls.phone"
          [required]="false"
          [phoneNumber]="user.phone"
        ></glxy-phone-input>
        <glxy-select-input
          label=""
          [formControl]="userFormGroup.controls.languages"
          [options]="emailLanguages"
          [hint]="'CREATE_BUSSINESS_USER_PAGE.LANGUAGE_HINT'"
        ></glxy-select-input>
      </form>
    </mat-card-content>
  </mat-card>
</ng-template>

<ng-template #loadingPage>
  <div class="loading-page-spinner">
    <mat-spinner diameter="45"></mat-spinner>
  </div>
</ng-template>

<ng-template #customFields>
  <ng-container *ngIf="iamUserId$ | async as userId; else loadingPage">
    <aux-auxiliary-data-table
      #auxiliarydatatable
      [partnerId]="partnerId$ | async"
      [objectType]="auxiliaryDataObjectType"
      [objectId]="userId"
      [auxiliaryDataAdminURL]="'/custom-fields?objectType=user'"
    ></aux-auxiliary-data-table>
  </ng-container>
</ng-template>
